

const PlantationInfoModal = ({
  isOpen,
  onClose,
  message,
  title = "Planting Recommendation",
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="modal-backdrop"
      onClick={onClose}
      aria-modal="true"
      role="dialog"
      aria-labelledby="plantation-modal-title"
      aria-describedby="plantation-modal-description"
    >
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <header className="modal-header">
          <div className="title-container">
            <svg
                className="title-icon"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                focusable="false"
              >
                <path
                  d="M12 22V12M12 12C9 9 7 5 7 3C7 3 10 4 12 7C14 4 17 3 17 3C17 5 15 9 12 12Z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M7 12C5 14 4 17 4 19C4 19 7 18 9 16"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M17 12C19 14 20 17 20 19C20 19 17 18 15 16"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

            <h5 id="plantation-modal-title" className="plantation-modal-title">{title}</h5>
          </div>
          <button
            type="button"
            className="close-button"
            onClick={onClose}
            aria-label="Close modal"
          >
            <svg viewBox="0 0 24 24" width="24" height="24">
              <path fill="currentColor" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
            </svg>
          </button>
        </header>

        <section className="modal-body">
          <div className="icon-container">
            <svg className="main-icon" viewBox="0 0 24 24">
              <path fill="currentColor" d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,16.5L6.5,12L7.91,10.59L11,13.67L16.09,8.59L17.5,10L11,16.5Z" />
            </svg>
          </div>
          <h5 className="message">{message}</h5>
          <p id="plantation-modal-description" className="description">
            <svg className="info-icon" viewBox="0 0 24 24">
              <path fill="currentColor" d="M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
            </svg>
            Based on current season and weather conditions.
          </p>
        </section>
        
        <footer className="modal-footer">
          <button className="action-button" onClick={onClose}>
            Got it!
          </button>
        </footer>

        <style jsx>{`
          .modal-backdrop {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(16, 42, 36, 0.85);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1000;
            animation: fadeIn 0.3s ease-out;
          }
            .plantation-modal-title{
            color: #ffffff;}
          
          .modal-container {
            background: linear-gradient(to bottom, #ffffff, #f8fdf9);
            border-radius: 20px;
            width: 90%;
            max-width: 450px;
            overflow: hidden;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(82, 143, 102, 0.1);
            animation: scaleIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
            transform-origin: center;
          }
          
          .modal-header {
            background: linear-gradient(135deg, #2e7d32 0%, #4caf50 100%);
            color: white;
            padding: 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
          }
          
          .title-container {
            display: flex;
            align-items: center;
            gap: 12px;
          }
          
          .title-icon {
            width: 28px;
            height: 28px;
            filter: drop-shadow(0 2px 3px rgba(0, 0, 0, 0.2));
          }
          
          .modal-header h5 {
            margin: 0;
            font-weight: 600;
            font-size: 1.35rem;
            letter-spacing: 0.5px;
          }
          
          .close-button {
            background: rgba(255, 255, 255, 0.2);
            border: none;
            border-radius: 50%;
            width: 36px;
            height: 36px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.2s ease;
            color: white;
          }
          
          .close-button:hover {
            background: rgba(255, 255, 255, 0.3);
            transform: rotate(90deg);
          }
          
          .modal-body {
            padding: 30px 25px;
            text-align: center;
          }
          
          .icon-container {
            margin-bottom: 20px;
          }
          
          .main-icon {
            width: 70px;
            height: 70px;
            color: #4caf50;
            filter: drop-shadow(0 4px 8px rgba(76, 175, 80, 0.3));
          }
          
          .message {
            color: #2e7d32;
            font-weight: 600;
            font-size: 1.2rem;
            margin: 0 0 20px 0;
            line-height: 1.5;
          }
          
          .description {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            color: #78909c;
            font-size: 0.95rem;
            margin: 0;
          }
          
          .info-icon {
            width: 18px;
            height: 18px;
            color: #78909c;
          }
          
          .modal-footer {
            padding: 0 25px 25px;
            display: flex;
            justify-content: center;
          }
          
          .action-button {
            background: linear-gradient(to right, #2e7d32, #4caf50);
            color: white;
            border: none;
            border-radius: 50px;
            padding: 12px 30px;
            font-weight: 600;
            font-size: 1rem;
            cursor: pointer;
            transition: all 0.3s ease;
            box-shadow: 0 4px 10px rgba(76, 175, 80, 0.3);
          }
          
          .action-button:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 15px rgba(76, 175, 80, 0.4);
          }
          
          .action-button:active {
            transform: translateY(0);
          }
          
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          
          @keyframes scaleIn {
            from { 
              opacity: 0;
              transform: scale(0.9);
            }
            to { 
              opacity: 1;
              transform: scale(1);
            }
          }
          
          /* Responsive adjustments */
          @media (max-width: 480px) {
            .modal-container {
              width: 95%;
              border-radius: 16px;
            }
            
            .modal-header {
              padding: 16px;
            }
            
            .modal-body {
              padding: 25px 20px;
            }
            
            .message {
              font-size: 1.1rem;
            }
          }
        `}</style>
      </div>
    </div>
  );
};
export default PlantationInfoModal;